import * as React from "react"
import { cn } from "@/lib/utils"

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  description?: string
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, description, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        <textarea
          className={cn(
            "flex min-h-[80px] w-full rounded-[5px] border border-slate-300 bg-white px-3 py-2 text-sm text-[#3f4652] placeholder:text-slate-300",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300 focus-visible:ring-offset-0 focus-visible:border-slate-300",
            "disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
          ref={ref}
          {...props}
        />
        {description && <p className="text-xs font-medium text-[#9eafc7]">{description}</p>}
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
